import React, { useCallback } from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import SelectedElementCollection from "./select-multiple/partial/selected-element-collection";
import styles from "./SelectStyles.css.js";

const SelectComponent = ({
  classes,
  label,
  id,
  value,
  handleChange,
  handleClick = void 0,
  name,
  elements,
  getValueFromElement,
  getLabelFromElement,
  itemKey,
  itemValue,
  itemLabel,
  multiple = false,
  disabled = false,
}) => {
  const onClick = useCallback(
    e => {
      if (!handleClick) return;
      handleClick(e);
    },
    [handleClick],
  );

  return (
    <FormControl className={classes.fullWidth} onClick={onClick}>
      <InputLabel id={`multiple-select-${id}`}>{label}</InputLabel>
      <Select
        disabled={disabled}
        name={name}
        onChange={event => {
          try {
            handleChange(event);
          } catch (error) {
            console.error("Error handling change event:", error);
          }
        }}
        value={value}
        multiple={multiple}
        renderValue={selected => {
          return multiple ? (
            <SelectedElementCollection
              selected={selected}
              elements={elements}
              getValueFromElement={getValueFromElement}
              getLabelFromElement={getLabelFromElement}
            />
          ) : (
            <span>{elements?.find(item => item[itemValue] === selected)?.[itemLabel]}</span>
          );
        }}
        getValueFromElement={getValueFromElement}
        getLabelFromElement={getLabelFromElement}
        id={id}
      >
        {elements?.map(c => (
          <MenuItem
            classes={{
              root: classes.menuItem,
            }}
            key={c[itemKey]}
            value={c[itemValue]}
          >
            {c[itemLabel]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

SelectComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  elements: PropTypes.arrayOf(PropTypes.object).isRequired,
  getValueFromElement: PropTypes.func.isRequired,
  getLabelFromElement: PropTypes.func.isRequired,
  itemKey: PropTypes.string.isRequired,
  itemValue: PropTypes.string.isRequired,
  itemLabel: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(SelectComponent);
